import React, { Component } from "react";
import { Table } from "antd";

class StageDropsTable extends Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    // const innerHeight = this.props.viewportHeight;

    this.columns = [
      // {
      //   title: "Drop",
      //   width: 80,
      //   dataIndex: "img",
      //   key: "img",
      //   align: "left",
      //   render: (text, record) => (
      //     <img
      //       src={"https://onestoppress.com/images/" + record.img + ".png"}
      //       alt={record.name}
      //     />
      //   ),
      // },
      {
        title: "Drop Name",
        width: 120,
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Chance",
        dataIndex: "drop_chance",
        key: "drop_chance",
        width: 60,
        align: "left",
        render: (text, record) => <div>{record.drop_chance}%</div>,
      },
      {
        title: "Count",
        dataIndex: "drop_count",
        key: "drop_count",
        width: 60,
        align: "left",
      },
    ];

    return (
      <Table
        columns={this.columns}
        dataSource={this.props.drops}
        scroll={{ x: 320 }}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              View all drops in this stage: from power-ups to units and more!
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSizeOptions: ["25", "50", "100", "600"],
        }}
      />
    );
  }
}

export default StageDropsTable;



// WEBPACK FOOTER //
// ./src/components/table/StageDropsTable.js